import { salesContactFormUrl } from "@clockwise/client-commons/src/constants/site";
import { InfoOutlined } from "@clockwise/design-system/icons";
import React from "react";

export const M365BetaCallout = () => {
  return (
    <div className="cw-flex cw-justify-center cw-items-center cw-w-full cw-rounded cw-py-5 cw-px-3 cw-mt-7 cw-mb-4 cw-bg-warning cw-font-bold cw-body-base">
      <InfoOutlined className="cw-text-neutral cw-mr-2" />
      <div>
        Everyone in your organization currently has access to the Teams plan as part of the
        Clockwise for Microsoft Beta.{" "}
        <a
          href={salesContactFormUrl}
          rel="noreferrer"
          target="_blank"
          className="cw-underline cw-cursor-pointer cw-text-default hover:cw-text-default-hover"
        >
          Contact sales
        </a>{" "}
        for questions.
      </div>
    </div>
  );
};
